export default {
    /**
     * Post 案件ホーム情報取得
     */
    loadCmpProjHome () {
        return axios.get(route('cmp.projs.home'))
    },

    /**
     * post 一覧案件情報更新
     */
    changeCmpProjInfoCommon (data) {
        return axios.post(route('cmp.proj.info.change'), data)
    },

    /**
     * Post 案件情報登録/更新
     */
    saveCmpProjInfo (data) {
        return axios.post(route('cmp.proj.save'), data)
    },

    /**
     * Get 案件情報詳細取得
     */
    loadCmpProjInfo (data) {
        return axios.get(route('cmp.proj.detail', data.id))
    },
    
    /**
     * Post 案件終了
     */
    cmpProjOff (data) {
        return axios.post(route('cmp.proj.off'), data)
    },

    /**
     * Post 案件物理削除
     */
    cmpProjDel (data) {
        return axios.post(route('cmp.proj.del'), data)
    },

    /**
     * Post 案件公開
     */
    cmpProjPublic (data) {
        return axios.post(route('cmp.proj.public'), data)
    },

    /**
     * Post 単価公開
     */
    cmpProjPricePub (data) {
        return axios.post(route('cmp.proj.price.pub'), data)
    },

    /**
     * Post 備考
     */
    cmpProjNote (data) {
        return axios.post(route('cmp.proj.note'), data)
    },

    /**
     * Get 言語分析
     */
    loadLangGraph () {
        return axios.get(route('cmp.lang.graph'))
    },
}
